import { COLLECTION_NOTICE_CONCEPTS_IDS, COUNTRY_CODES } from '@core/constants';
import {
  CollectionNoticeModel,
  StudentAdministrativeRuleModel,
} from '@core/models';

export function isElegibleForPaymentSV(
  collectionNotices: CollectionNoticeModel[],
  pendingAdministrativeRules: StudentAdministrativeRuleModel[]
): boolean {
  if (
    !collectionNotices.every(
      (cs) =>
        cs.countryCode.toLowerCase() === COUNTRY_CODES.SV &&
        cs.concept.id === COLLECTION_NOTICE_CONCEPTS_IDS.IN
    )
  ) {
    return false;
  }
  return pendingAdministrativeRules.every((adminRule) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (adminRule.administrativeRule === null) {
      return true;
    }
    return false;
  });
}
